"use client";
import React, { useTransition } from "react";

import { Metadata } from "next";
import { getImagePath } from "@/lib/utils";
import Image from "next/image";
import Breadcrumb from "@/components/Common/Breadcrumb";
import { Card, CardContent } from "@/components/ui/card";
import testimonials from "@/components/Testimonials/testimonialsData";
import { Testimonial } from "@/types/testimonial";
import SingleTestimonial from "@/components/Testimonials/SingleTestimonial";
import { useTranslations } from "next-intl";

// export const metadata: Metadata = {
//   title: "About Page | Kissa Shuru Talkies",
//   description: "This is About Page for Startup Nextjs Template",
//   // other metadata
// };

const Testimonials = () => {
  const t = useTranslations("testimonials");

  return (
    <section className="section-padding bg-white py-24">
      <Breadcrumb
        pageName={t("pagename")}
        description=""
        bgImages={[getImagePath("/images/breadcrumb/howItWorks.webp")]}
        bgIndex={0}
      />

      <div className="container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-5 pt-0 px-6">
        {testimonials.map((testimonial, idx: number) => (
          <Card
            key={idx}
            className="bg-white/95 backdrop-blur-sm shadow-md text-center shadow-warm h-full flex flex-col justify-between py-10 rounded-tl-3xl rounded-br-3xl transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl"
          >
            <CardContent className="p-6 text-center flex flex-col h-full">
              <p className="text-warm-800 mb-6 leading-relaxed flex-1">
                {t(`content${testimonial.id}`)}
              </p>
              <div className="mb-4 flex justify-center">
                <Image
                  src={testimonial.image.src}
                  alt={t(`name${testimonial.id}`)}
                  width={testimonial.image.width}
                  height={testimonial.image.height}
                  className="h-20 w-20 rounded-lg object-cover"
                />
              </div>
              <div className="">
                <div className="font-semibold text-warm-800">
                  {" "}
                  {t(`name${testimonial.id}`)}
                </div>
                <div className="text-sm text-warm-300">
                  {t(`location${testimonial.id}`)}
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
